module.exports = __webpack_public_path__ + "media/Father-in-law.de1f7d0b.mp3";